export enum TerpeneDisplayType {
  Exact = 'exact',
  Range = 'range'
}
